import { Loader2 } from 'lucide-react';

function ConflictList({ items, tone, testId }) {
  return (
    <div className={`max-h-32 overflow-y-auto text-xs border rounded p-2 space-y-0.5 ${tone}`} data-testid={testId}>
      {items.slice(0, 50).map((c, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="font-mono text-[10px] text-slate-500">{c.date}</span>
          <span className="font-semibold">{c.route_code}</span>
          <span>{c.employee_name}</span>
        </div>
      ))}
      {items.length > 50 && <div className="text-[10px] text-slate-400 italic pt-1">+{items.length - 50} daha</div>}
    </div>
  );
}

// Kopyalama önizlemesindeki çakışmalar: izinliler hiç kopyalanmaz, çift atamalar isteğe bağlı eklenir.
export function CopyConflictsSection({ preview, loading, onToggleIncludeDouble }) {
  const conflicts = preview.conflicts || [];
  const leave = conflicts.filter((c) => c.reason === 'leave');
  const doubles = conflicts.filter((c) => c.reason === 'double');
  const include = !!preview.include_double;
  if (leave.length === 0 && doubles.length === 0) return null;
  return (
    <div className="space-y-3">
      {doubles.length > 0 && (
        <div>
          <div className="text-xs font-semibold text-orange-700 mb-1">
            Çift atama çakışmaları ({doubles.length}) — {include ? 'yine de eklenecek' : 'atlanacak'}
          </div>
          <ConflictList items={doubles} tone="bg-orange-50/50" testId="copy-pv-double-list" />
          <label className="mt-2 flex items-center gap-2 text-xs font-medium cursor-pointer select-none" data-testid="copy-include-double-label">
            <input
              type="checkbox"
              checked={include}
              disabled={loading}
              onChange={(e) => onToggleIncludeDouble(e.target.checked)}
              className="h-3.5 w-3.5 accent-orange-600"
              data-testid="copy-include-double-checkbox"
            />
            Çakışanları da ekle (önceki haftadaki gibi birebir kopyala)
            {loading && <Loader2 className="h-3 w-3 animate-spin" />}
          </label>
        </div>
      )}
      {leave.length > 0 && (
        <div>
          <div className="text-xs font-semibold text-purple-700 mb-1">İzinli çalışanlar ({leave.length}) — kopyalanmayacak</div>
          <ConflictList items={leave} tone="bg-purple-50/50" testId="copy-pv-leave-list" />
        </div>
      )}
    </div>
  );
}
